import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { CategoriaOsService } from './tipo-os-service/categoria-os.service';
import { TipoOsService } from './tipo-os-service/tipo-os.service';
import { TipoOsComponent } from './tipo-os.component';

@NgModule({
  imports: [
    HttpModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    CommonModule,
    ComumModule,
    TooltipModule,
    DialogModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    TipoOsComponent
  ],
  declarations: [
    TipoOsComponent
  ],
  providers: [
    TipoOsService,
    CategoriaOsService
  ]
})
export class TipoOsModule { }
